import { ImageAsset } from '../images/image-asset-model';
import { ImageAssetItem } from '../images/image-asset-item.model';
import { ImageAssetEditWrapper } from '../../sections/albums/album-image-asset/album-image-asset.component';
import { AppTeamUtil } from '../../core/app-team-util';

export class Album
{
    CategoryIds: number[] = [];
    ChildAlbums: Album[] = [];
    Description?: string;
    Id!: number;
    ImageAssets: ImageAssetEditWrapper[] = [];
    IsFolder = false;
    IsPublished = true;
    Name!: string;
    ParentId?: number;
    Photo?: ImageAsset;
    PhotoAutoAssigned = false;
    PhotoId = -1;
    PhotosCount = 0;
    PublishDate?: Date;
    Thumbnail?: ImageAsset;
    VideosCount = 0;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json.Photo) this.Photo = new ImageAsset(json.Photo);
            if (json.Thumbnail) this.Thumbnail = new ImageAsset(json.Thumbnail);
            if (json.ImageAssets) this.ImageAssets = json.ImageAssets.map((json: any) => new ImageAsset(json));
            if (json.ChildAlbums) this.ChildAlbums = json.ChildAlbums.map((json: any) => new Album(json));
            this.PublishDate = AppTeamUtil.convertApiDateStringToDate(json['PublishDate']);

            // @ts-ignore
            delete this['Breadcrumbs'];
            // @ts-ignore
            delete this['Order'];
        }
    }
}
